import React from 'react';
import {connect} from 'react-redux';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';

import { LOG_LEVELS } from "../../utils/logger";
import Logger from "../../utils/logger";
import { withFullStoryExclude } from '../../utils/fullStoryHelper';

const log = new Logger('CLOSED_RETURNS_DETAILS_MODAL', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES =  {
    modal: 'modal-full-width-height'
};

class ClosedReturnsDetailsModal extends React.Component {
  render() {
    log.debug('render(): ', this.props);

    const rowData = this.props.vatReturnDetails || {};

    const closedReturnSummaryTable = (
      <div>
        <h2><LanguageStringResolver string='returnsHistory_FilingSummary'/></h2>
        <table>
          <thead>
            <tr>
              <th><LanguageStringResolver string='returnsHistory_Frequency'/></th>
              <th><LanguageStringResolver string='returnsHistory_Period'/></th>
              <th><LanguageStringResolver string='returnsHistory_CompanyCode'/></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{this.props.periodName}</td>
              <td>{rowData.periodStartDate} - {rowData.periodEndDate}</td>
              <td>({rowData.companyCode}) - {this.props.companyName} </td>
            </tr>
          </tbody>
        </table>
      </div>
    );

    const vatBoxesTable = (
      <div><h2>VAT</h2>
        <table>
          <thead>
          <tr>
            <th><LanguageStringResolver string='returnsHistory_BoxName'/></th>
            <th><LanguageStringResolver string='returnsHistory_BoxValue'/></th>
          </tr>
          </thead>
          <tbody>
          {rowData.vatBoxes.map((box) => {
             return (
               <tr key={box.boxName}>
                 <td>{box.boxName}</td>
                 <td className={withFullStoryExclude()}><FormattedCurrencyValue className="float-right" value={box.boxValue}/></td>
               </tr>
             )
          })}
          </tbody>
        </table>
      </div>
    );

    const taxableBasisBoxesTable = (
      <div><h2>Taxable Basis</h2>
        <table>
          <thead>
          <tr>
            <th><LanguageStringResolver string='returnsHistory_BoxName'/></th>
            <th><LanguageStringResolver string='returnsHistory_BoxValue'/></th>
          </tr>
          </thead>
          <tbody>
          {rowData.taxableBasisBoxes.map((box) => {
            return (
              <tr key={box.boxName}>
                <td>{box.boxName}</td>
                <td className={withFullStoryExclude()}><FormattedCurrencyValue className="float-right" value={box.boxValue}/></td>
              </tr>
            )
          })}
          </tbody>
        </table>
      </div>
    );

    return (
      <span>
        <Modal
          classNames={MODAL_CLASSNAMES}
          open={this.props.showModal}
          onClose={this.props.onCloseModal}
          closeOnEsc={true}
          blockScroll={true}
          closeOnOverlayClick={true}
          center
        >
          {closedReturnSummaryTable}
          <s-row>
            <s-col span="6">{taxableBasisBoxesTable}</s-col>
            <s-col span="6">{vatBoxesTable}</s-col>
          </s-row>

        </Modal>
      </span>
    );
  };
}


ClosedReturnsDetailsModal.defaultProps = {
  showModal: false,
  vatReturnDetails: {},
  onCloseModal: () => {},
  companyName: "MISSING",
  periodName: "MISSING"
};

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(ClosedReturnsDetailsModal);